// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3-H12","footer":"Form_footer__3TKoj"};